import { Pipe, PipeTransform } from '@angular/core';
import { TableConfig } from '../table-config';
import { TableEditMode } from '../table-edit-mode';

@Pipe({
  name: 'colSpan',
})
export class ColSpanPipe implements PipeTransform {
  transform(config: TableConfig): number {
    let cols = !config ? 0 : config.columns.length + Number(config.enableDelete) + Number(config.enableSelectionColumn);

    if (config && config.editMode !== TableEditMode.Cell && config.enableEdit) {
      cols += 1;
    }

    if (config && config.rowHighlightFunction && config.showRowHighlightInfoColumn) {
      cols += 1;
    }

    return cols;
  }
}
